/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        blockType: BlockType.CODE,
        template: `
#include <zephyr/net/mqtt.h>
        `,
    });

    blocks.push({
        location: 'PRJ_CONF',
        blockType: BlockType.CODE,
        template: `
# Enable MQTT
CONFIG_MQTT_LIB=y
# CONFIG_MQTT_LIB_TLS=y
CONFIG_MQTT_KEEPALIVE=60`,
    });

    return blocks;
};
